import { render } from "./ScoreMatch.vue?vue&type=template&id=c2a94586&scoped=true"
import script from "./ScoreMatch.vue?vue&type=script&lang=js"
export * from "./ScoreMatch.vue?vue&type=script&lang=js"

import "./ScoreMatch.vue?vue&type=style&index=0&id=c2a94586&scoped=true&lang=css"

import exportComponent from "/home/lbecker/git/usssa-score/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a94586"]])

export default __exports__